<div class="cx-wrap">
  <!-- P6:1280-1295 -->
  <div class="cx-bar">
    <agu-crumb [Trail]="Trail" (Navigate)="Navigate($event)" />
    <span class="sp"></span>
    <span class="cx-pow">Powered by <b>Julius</b></span>
    <button class="cx-how" type="button" (click)="OpenAbout()">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.6 9.3a2.5 2.5 0 0 1 4.8.9c0 1.7-2.4 2.2-2.4 3.6M12 17h.01"/></svg>How this works
    </button>
    <div class="cx-mm">
      <button class="cx-how cx-mmb" type="button" aria-haspopup="menu" [attr.aria-expanded]="MenuOpen" aria-label="More about Career Explorer" (click)="ToggleMenu()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="5" cy="12" r="1.8"/><circle cx="12" cy="12" r="1.8"/><circle cx="19" cy="12" r="1.8"/></svg>
      </button>
      @if (MenuOpen) {
        <div class="cx-mmp" role="menu" (keydown)="OnMenuKeydown($event)">
          <button type="button" role="menuitem" (click)="OpenAbout()">About the product</button>
          @if (PrivacyUrl) {
            <a role="menuitem" [href]="PrivacyUrl" target="_blank" rel="noopener">Privacy policy
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></svg></a>
          }
          @if (TermsUrl) {
            <a role="menuitem" [href]="TermsUrl" target="_blank" rel="noopener">Terms of use
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></svg></a>
          }
          @if (ContactEmail) {
            <a role="menuitem" [href]="ContactHref">Contact us</a>
          }
        </div>
      }
    </div>
  </div>

  <!-- the one polite live region: status text only -->
  <p class="cx-sr" role="status" aria-live="polite">{{ StatusText }}</p>
  <div class="cx-body">
    @if (Lapsed) {
      <agu-state-panel Variant="lock" [Icon]="LockCopy.Icon" [Title]="LockCopy.Title" [Body]="LockCopy.Body" PrimaryLabel="Renew membership" SecondaryLabel="Compare membership options" (Primary)="OnRenew()" (Secondary)="OnRenew()" />
    } @else if (loading) {
      <agu-skeleton [Count]="3" />
    } @else if (loadError) {
      <agu-state-panel Variant="error" Icon="alert" Title="We could not load Career Explorer"
          Body="Something went wrong on our side, not yours."
          PrimaryLabel="Try again" (Primary)="Retry()" />
    } @else {
      @if (RereadBanner) {
        <agu-state-banner Tone="amber" [Text]="RereadBanner" />
      }
      @if (pollTroubled) {
        <agu-state-banner Tone="error" Text="We are having trouble checking on your CV. We will keep trying." />
      }
      @if (matchesError) {
        <agu-state-banner Tone="error" [Text]="matchesError" ActionLabel="Try again" (Action)="Retry()" />
      }

      @if (view === 'start' || ReadingStepIndex !== null) {
        <ra-cx-start
            [Mode]="StartMode" [Consent]="consent" [PrivacyUrl]="PrivacyUrl" [Uploading]="uploading"
            [Heading]="ReadingHeading" [Step]="StartStep" [FileName]="cv?.fileName ?? ''" [NotProcessed]="NotProcessed"
            [UploadError]="uploadError" [AutoOpen]="replacing" [CanKeep]="CanKeepCurrent"
            (ConsentChange)="OnConsentChange($event)" (FileChosen)="OnFileChosen($event)" (Refused)="OnRefused($event)"
            (ChooseAnother)="Replace()" (UseProfile)="OpenProfile()" (Keep)="KeepCurrent()" />
      } @else {
        @if (view === 'review') {
          <section class="cx-reviewing">
            <ra-cx-review
                [Cards]="ReviewCards" [Category]="ReviewCategoryNow" [StatedCount]="ReviewStatedCount" [PendingByCategory]="ReviewPending"
                [Cv]="cv" [DownloadUrl]="downloadUrl"
                (Accept)="OnReviewDecision($event, 'approved')" (Decline)="OnReviewDecision($event, 'declined')" (AcceptAll)="OnAcceptAll()"
                (Next)="OnReviewNext($event)" (DismissNote)="OnDismissNote()" (SeePaths)="OpenPaths()" (ViewerFailed)="OnViewerFailed()" />
          </section>
        } @else {
        @if (!parseOnly && matches && view === 'paths') {
          <ra-cx-paths [Matches]="matches" [Profiles]="profiles" />
        } @else if (!parseOnly && matches && view === 'role') {
          @if (CurrentRole; as role) {
            <ra-cx-role
                [Match]="role" [Profile]="CurrentProfile" [Narrative]="RoleNarrative" [NarrativeLoading]="narrativeLoading"
                [Openings]="RoleOpenings" [OpeningsState]="RoleOpeningsState"
                (Assert)="OnAssert($event)" (OpenJob)="OnOpenJob($event)" (SeeAllJobs)="OnSeeAllJobs()" (BrowseAllJobs)="OnBrowseAllJobs()" />
          } @else {
            <agu-state-panel Icon="search"
                Title="That career path is not on your list"
                Body="It may have changed when your CV was read again. Your current career paths are one step back."
                PrimaryLabel="Back to career paths" (Primary)="OpenPaths()" />
          }
        } @else {
          <ra-cx-ready
              [ParseOnly]="parseOnly" [ParseOnlyPanel]="parseOnly ? ParseOnlyPanel : null" [Matches]="matches" [Profiles]="profiles" [Cv]="cv" [Tags]="cv?.tags ?? []" [Cards]="ReviewCards" [DownloadUrl]="downloadUrl" [AssertOutcome]="assertOutcome"
              (ExploreAll)="OpenPaths()" (Review)="OnReviewNext($event)"
              (Accept)="OnReviewDecision($event, 'approved')" (Decline)="OnReviewDecision($event, 'declined')"
              (Undo)="OnReviewDecision($event, 'unreviewed')" (Assert)="OnAssert($event)" (Retract)="OnRetract($event)" (Replace)="Replace()" (Delete)="Delete()" />
        }
        }
      }
    }
  </div>
</div>

<ra-cx-about-dialog [Open]="AboutOpen" (Closed)="CloseAbout()" />
